var map = {
	"./standard/Dashboard": 489,
	"./standard/Dashboard.scss": 607,
	"./standard/Dashboard.tsx": 489,
	"./standard/Declare": 487,
	"./standard/Declare.scss": 608,
	"./standard/Declare.tsx": 487,
	"./standard/Edumain": 468,
	"./standard/Edumain.scss": 609,
	"./standard/Edumain.tsx": 468,
	"./standard/Eduresult": 485,
	"./standard/Eduresult.scss": 610,
	"./standard/Eduresult.tsx": 485,
	"./standard/Exam": 486,
	"./standard/Exam.scss": 611,
	"./standard/Exam.tsx": 486,
	"./standard/Faq": 469,
	"./standard/Faq.scss": 612,
	"./standard/Faq.tsx": 469,
	"./standard/Intro": 470,
	"./standard/Intro.scss": 613,
	"./standard/Intro.tsx": 470,
	"./standard/Login": 471,
	"./standard/Login.scss": 316,
	"./standard/Login.tsx": 471,
	"./standard/Mudlogin": 472,
	"./standard/Mudlogin.scss": 473,
	"./standard/Mudlogin.tsx": 472,
	"./standard/Mudmanage": 474,
	"./standard/Mudmanage.scss": 614,
	"./standard/Mudmanage.tsx": 474,
	"./standard/Mypage": 475,
	"./standard/Mypage.scss": 615,
	"./standard/Mypage.tsx": 475,
	"./standard/Target": 488,
	"./standard/Target.scss": 632,
	"./standard/Target.tsx": 488,
	"./standard/Template": 482,
	"./standard/Template.scss": 633,
	"./standard/Template.tsx": 482,
	"./standard/edumain/Edulogin": 634,
	"./standard/edumain/Edulogin.tsx": 634,
	"./standard/edumain/Eduplay": 688,
	"./standard/edumain/Eduplay.tsx": 688,
	"./standard/edumain/Findpassword": 640,
	"./standard/edumain/Findpassword.tsx": 640,
	"./standard/edumain/Setpassword": 641,
	"./standard/edumain/Setpassword.tsx": 641,
	"./standard/exam/Bytarget": 642,
	"./standard/exam/Bytarget.tsx": 642,
	"./standard/exam/Bytemplate": 643,
	"./standard/exam/Bytemplate.tsx": 643,
	"./standard/exam/Infectionpc": 689,
	"./standard/exam/Infectionpc.tsx": 689,
	"./standard/exam/Leakfile": 690,
	"./standard/exam/Leakfile.tsx": 690,
	"./standard/exam/Pi": 686,
	"./standard/exam/Pi.tsx": 686,
	"./standard/exam/Tag": 644,
	"./standard/exam/Tag.tsx": 644,
	"./standard/login/Active": 645,
	"./standard/login/Active.tsx": 645,
	"./standard/login/Already": 646,
	"./standard/login/Already.tsx": 646,
	"./standard/login/Basic": 647,
	"./standard/login/Basic.tsx": 647,
	"./standard/login/First": 648,
	"./standard/login/First.tsx": 648,
	"./standard/login/Otp": 649,
	"./standard/login/Otp.tsx": 649,
	"./standard/login/Pwreset": 650,
	"./standard/login/Pwreset.tsx": 650,
	"./standard/login/Register": 651,
	"./standard/login/Register.tsx": 651,
	"./standard/mudlogin/Admin": 652,
	"./standard/mudlogin/Admin.tsx": 652,
	"./standard/mudlogin/Adminfirst": 653,
	"./standard/mudlogin/Adminfirst.tsx": 653,
	"./standard/mudlogin/Pwchange": 654,
	"./standard/mudlogin/Pwchange.tsx": 654,
	"./standard/mudmanage/Api": 655,
	"./standard/mudmanage/Api.tsx": 655,
	"./standard/mudmanage/Attach": 679,
	"./standard/mudmanage/Attach.tsx": 679,
	"./standard/mudmanage/Basicconf": 656,
	"./standard/mudmanage/Basicconf.tsx": 656,
	"./standard/mudmanage/Conf.scss": 103,
	"./standard/mudmanage/Edubasic": 657,
	"./standard/mudmanage/Edubasic.tsx": 657,
	"./standard/mudmanage/Edutemplate": 376,
	"./standard/mudmanage/Edutemplate.tsx": 376,
	"./standard/mudmanage/Eduuser": 659,
	"./standard/mudmanage/Eduuser.tsx": 659,
	"./standard/mudmanage/Examing": 687,
	"./standard/mudmanage/Examing.tsx": 687,
	"./standard/mudmanage/Examtemplate": 372,
	"./standard/mudmanage/Examtemplate.tsx": 372,
	"./standard/mudmanage/License": 684,
	"./standard/mudmanage/License.tsx": 684,
	"./standard/mudmanage/Log": 685,
	"./standard/mudmanage/Log.tsx": 685,
	"./standard/mudmanage/Monit": 660,
	"./standard/mudmanage/Monit.tsx": 660,
	"./standard/mudmanage/Netdata": 661,
	"./standard/mudmanage/Netdata.tsx": 661,
	"./standard/mudmanage/Phishingpage": 373,
	"./standard/mudmanage/Phishingpage.tsx": 373,
	"./standard/mudmanage/Rabbitmq": 662,
	"./standard/mudmanage/Rabbitmq.tsx": 662,
	"./standard/mudmanage/Setting": 663,
	"./standard/mudmanage/Setting.scss": 664,
	"./standard/mudmanage/Setting.tsx": 663,
	"./standard/mudmanage/Smtpconf": 665,
	"./standard/mudmanage/Smtpconf.tsx": 665,
	"./standard/mudmanage/Subadmin": 681,
	"./standard/mudmanage/Subadmin.tsx": 681,
	"./standard/mudmanage/Syncconf": 691,
	"./standard/mudmanage/Syncconf.tsx": 691,
	"./standard/mudmanage/Target": 680,
	"./standard/mudmanage/Target.tsx": 680,
	"./standard/mudmanage/User": 682,
	"./standard/mudmanage/User.tsx": 682,
	"./standard/mypage/Declare": 666,
	"./standard/mypage/Declare.tsx": 666,
	"./standard/mypage/Edu": 667,
	"./standard/mypage/Edu.tsx": 667,
	"./standard/mypage/License": 692,
	"./standard/mypage/License.scss": 668,
	"./standard/mypage/License.tsx": 692,
	"./standard/mypage/Notification": 669,
	"./standard/mypage/Notification.tsx": 669,
	"./standard/mypage/Profile": 670,
	"./standard/mypage/Profile.scss": 671,
	"./standard/mypage/Profile.tsx": 670,
	"./standard/mypage/Share": 693,
	"./standard/mypage/Share.scss": 672,
	"./standard/mypage/Share.tsx": 693,
	"./standard/mypage/Smtp": 673,
	"./standard/mypage/Smtp.tsx": 673,
	"./standard/template/Edubasic": 674,
	"./standard/template/Edubasic.tsx": 674,
	"./standard/template/Edutemplate": 675,
	"./standard/template/Edutemplate.tsx": 675,
	"./standard/template/Eduuser": 676,
	"./standard/template/Eduuser.tsx": 676,
	"./standard/template/Examtemplate": 677,
	"./standard/template/Examtemplate.tsx": 677,
	"./standard/template/Phishingpage": 678,
	"./standard/template/Phishingpage.tsx": 678,
	"./standard/template/Quiz": 683,
	"./standard/template/Quiz.tsx": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1145;